import { render, staticRenderFns } from "./TestimonialsList.vue?vue&type=template&id=cf5a7cc6&scoped=true&"
import script from "./TestimonialsList.vue?vue&type=script&lang=js&"
export * from "./TestimonialsList.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsList.vue?vue&type=style&index=0&id=cf5a7cc6&lang=scss&scoped=true&"
import style1 from "./TestimonialsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5a7cc6",
  null
  
)

export default component.exports